export type FeedbackType = 'general' | 'bug' | 'feature_request' | 'account_deletion' | 'complaint' | 'praise';

export interface Feedback {
  id: string;
  type: FeedbackType;
  message: string;
  rating?: number;
  name?: string;
  email?: string;
  phoneNumber?: string;
  createdAt: string;
  updatedAt?: string;
}

export interface FeedbackFilters {
  page?: number;
  limit?: number;
  type?: FeedbackType;
  sortBy?: 'createdAt' | 'rating';
  sortOrder?: 'asc' | 'desc';
}

export interface Pagination {
  total: number;
  totalPages: number;
  page: number;
  limit: number;
  offset: number;
  hasMore: boolean;
}

export interface FeedbacksResponse {
  feedbacks: Feedback[];
  pagination: Pagination;
}

export const FEEDBACK_TYPE_LABELS: Record<FeedbackType, string> = {
  general: 'Geral',
  bug: 'Bug/Erro',
  feature_request: 'Sugestao',
  account_deletion: 'Excluir conta',
  complaint: 'Reclamacao',
  praise: 'Elogio',
};

export const FEEDBACK_TYPE_COLORS: Record<FeedbackType, string> = {
  general: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  bug: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300',
  feature_request: 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300',
  account_deletion: 'bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-300',
  complaint: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-300',
  praise: 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300',
};
